module.exports = __webpack_public_path__ + "img/xz-icon.de18682b.png";